<div class="container-fluid">
  <div class="row">
    <div
      class="col-12 col-sm-5 d-none d-sm-flex flex-column min-full-height justify-content-between left-panel position-relative"
    >
      <img
        src="../../../assets/images/Logo-colorido.png"
        alt="Logo"
        class="logo"
      />
      <p class="bottom-text">
        Avoid The Headache, Get a Simple Solution That Meets Your Needs
      </p>
    </div>
    <div class="col-12 d-sm-none pt-5 px-4">
      <img
        src="../../../assets/images/Logo-colorido.png"
        alt="Logo"
        class="logo"
      />
    </div>
    <div class="col-12 col-sm-7">
      <div class="right-panel">
        <form (ngSubmit)="onSubmit()" class="login-form">
          <p class="title">Sign in</p>
          <div class="form-group">
            <label for="email" class="input-label">Email</label>
            <div class="input-group mb-3">
              <span class="input-group-text" id="basic-addon1">
                <i class="bi bi-envelope"></i>
              </span>
              <input
                type="email"
                class="form-control input-label"
                [(ngModel)]="usrEmail"
                (input)="checkFields()"
                name="email"
              />
            </div>
          </div>
          <div class="form-group">
            <label for="password" class="input-label" autocomplete="new-password">Password</label>
            <div class="input-group">
              <span class="input-group-text" id="basic-addon1">
                <i class="bi bi-lock"></i>
              </span>
              <input
                type="{{ showPassword ? 'text' : 'password' }}"
                class="form-control input-label"
                [(ngModel)]="usrPassword"
                name="password"
                #passwordInput
                (input)="checkFields()"
              />
              <div class="input-group-append" *ngIf="usrPassword">
                <span
                  class="input-group-text span-eye"
                  (click)="togglePasswordVisibility(passwordInput)"
                >
                  <i
                    class="bi bi-eye"
                    [ngClass]="{
                      'bi-eye-slash': showPassword,
                      'bi-eye': !showPassword,
                      'eye-slash-color': showPassword
                    }"
                    class="eye-icon"
                    (mouseover)="addHoverClass()"
                    (mouseout)="removeHoverClass()"
                  ></i>
                </span>
              </div>
            </div>
          </div>

          <div class="form-group div-Forgot">
            <a [routerLink]="['/forgot-password']" class="forgot-password">Forgot password?</a>
          </div>
          <div class="form-group">
            <button
              type="submit"
              class="sign-in-button btn btn-primary"
              [disabled]="!fieldsCompleted"
            >
              Sign in
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
